var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoHeart01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#5f1e5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.8298,17.3686h0c.381-.718,1.15-1.164,2.006-1.164.665,0,1.322.268,1.902.775l.662.579.663-.579c.579-.507,1.237-.774,1.901-.774.857,0,1.626.446,2.007,1.164.405.762.292,1.713-.313,2.612-.518.804-1.471,1.728-2.574,2.798-.546.529-1.108,1.075-1.685,1.67-.578-.597-1.143-1.146-1.692-1.678-1.098-1.065-2.046-1.985-2.575-2.807-.598-.887-.708-1.833-.302-2.596m7.134-2.462c-.907,0-1.789.323-2.563.935-.775-.613-1.657-.936-2.565-.936-1.338,0-2.546.711-3.153,1.854-.638,1.2-.504,2.63.364,3.919.602.936,1.603,1.906,2.761,3.03l.189-.192-.182.198c.591.574,1.203,1.168,1.823,1.817l.762.795.76-.795c.622-.65,1.235-1.245,1.829-1.82,1.16-1.126,2.163-2.098,2.753-3.016.876-1.301,1.013-2.735.376-3.935-.607-1.144-1.816-1.854-3.154-1.854",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5725,27.9701h-6.583l-1.59,2.514-1.589-2.514h-6.583c-.95,0-1.723-.773-1.723-1.724v-12.504c0-.95.773-1.723,1.723-1.723h16.345c.95,0,1.723.773,1.723,1.723v12.504c0,.951-.773,1.724-1.723,1.724m0-17.25H12.2275c-1.666,0-3.022,1.356-3.022,3.022v12.504c0,1.667,1.356,3.022,3.022,3.022h5.867l2.305,3.646,2.306-3.646h5.867c1.666,0,3.022-1.355,3.022-3.022v-12.504c0-1.666-1.356-3.022-3.022-3.022",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHeart01);
export default __webpack_public_path__ + "static/media/ico-heart-01.3b4d68098ffb9cbe62e951466aaa5d8e.svg";
export { ForwardRef as ReactComponent };